// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-preview{display:block;position:relative;-webkit-animation:opacity .7s ease-in 0s both running;animation:opacity .7s ease-in 0s both running}@-webkit-keyframes opacity{0%{filter:opacity(10%)}50%{filter:opacity(60%)}to{filter:opacity(100%)}}@keyframes opacity{0%{filter:opacity(10%)}50%{filter:opacity(60%)}to{filter:opacity(100%)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
